import {
  Directive,
  ElementRef,
  forwardRef,
  HostListener,
  Input,
} from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { applyMask, getUnmaskedValue } from './mask.utils';

@Directive({
  selector: 'input[mask]',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => AppMaskDirective),
      multi: true,
    },
  ],
})
export class AppMaskDirective implements ControlValueAccessor {
  @Input() mask: string;
  @Input() showMaskTyped: boolean;
  @Input() validation: boolean;

  private onChange: (value: string) => void = () => {};
  private onTouched: () => void = () => {};

  constructor(private el: ElementRef<HTMLInputElement>) {}

  writeValue(value: string): void {
    const raw = getUnmaskedValue(value);
    this.el.nativeElement.value = applyMask(raw, this.mask || '');
  }

  registerOnChange(fn: (value: string) => void): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  @HostListener('input')
  onInput(): void {
    const input = this.el.nativeElement;
    const raw = getUnmaskedValue(input.value);
    input.value = applyMask(raw, this.mask || '');
    this.onChange(raw);
  }

  @HostListener('blur')
  onBlur(): void {
    this.onTouched();
  }
}
